import React from 'react';
import styles from '../styles/SunsetScreen.module.css';
import twitterIcon from '../assets/twitterv2.svg';

const STATS = [
  { value: '3M+', label: 'KEI Minted', sublabel: 'Peak Supply' },
  { value: '$10M', label: 'Total Value Locked', sublabel: 'Peak TVL' },
  { value: '250+', label: 'Active Vaults', sublabel: 'Concurrent Peak' },
  { value: '1,500+', label: 'Vaults Opened', sublabel: 'Since Inception' },
];

const MILESTONES = [
  'First app to let users borrow against HYPE on the HyperEVM',
  'Second app to launch on the HyperEVM',
];

const SunsetScreen = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <span className={styles.wordmark}>KEIKO FINANCE</span>

        <h1 className={styles.title}>Thank You</h1>
        <p className={styles.body}>
          Keiko Finance has officially closed its doors. The app is no longer
          accessible. We're grateful to every user, borrower, and liquidity
          provider who trusted us building on the HyperEVM.
        </p>

        <div className={styles.statsGrid}>
          {STATS.map((stat) => (
            <div key={stat.label} className={styles.statCard}>
              <div className={styles.statValue}>{stat.value}</div>
              <div className={styles.statLabel}>{stat.label}</div>
              <div className={styles.statSublabel}>{stat.sublabel}</div>
            </div>
          ))}
        </div>

        <div className={styles.milestones}>
          {MILESTONES.map((milestone) => (
            <span key={milestone} className={styles.milestoneChip}>
              {milestone}
            </span>
          ))}
        </div>

        <div className={styles.footer}>
          <div className={styles.socials}>
            <a href="https://twitter.com/keikofinance" target="_blank" rel="noreferrer" className={styles.socialIcon}>
              <img src={twitterIcon} alt="Twitter" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SunsetScreen;
